module.exports = __webpack_public_path__ + "img/Training_Materials.7c0dafd5.jpg";